import { render, staticRenderFns } from "./Admin.container.vue?vue&type=template&id=15a11eb6&"
import script from "./Admin.container.vue?vue&type=script&lang=ts&"
export * from "./Admin.container.vue?vue&type=script&lang=ts&"
import style0 from "./Admin.container.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports